/* eslint-disable id-length */
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { navSelector } from 'common/store/modules/competition-nav/selectors';
import { changeSeason } from 'common/store/modules/competition-nav/thunks';

export const SeasonNavItem = ({ seasonsToShow }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const seasons = nav?.seasons;

    const filteredSeasons = useMemo(() => {
        const seasonsToShowArray = seasonsToShow
            ? seasonsToShow.replace(/ /g, '').split(',')
            : '';
        if (seasonsToShowArray?.length) {
            return seasons?.filter((season) => {
                return seasonsToShow.includes(season.providerId);
            });
        }

        return [];
    }, [seasons, seasonsToShow]);

    const selectedItemToString = (item) => item?.name.split(' ')[0];

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                className="w-100"
                items={filteredSeasons}
                itemToString={(season) => season?.name ?? ''}
                selectedItemToString={selectedItemToString}
                type="with-default"
                icon="season-trophy"
                initialSelectedItem={
                    filteredSeasons?.length && nav.season.id
                        ? filteredSeasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                activeItem={
                    filteredSeasons?.length && nav.season.id
                        ? filteredSeasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                isReadyToRender={() => filteredSeasons?.length && nav.season.id}
                label={getTranslation('label.stats.season')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeSeason({
                            season: selectedItem
                        })
                    );
                }}
            />
        </div>
    );
};

SeasonNavItem.propTypes = {
    seasonsToShow: PropTypes.string
};
